import { render, staticRenderFns } from "./ActivitySummary.vue?vue&type=template&id=3c5801ae&scoped=true&"
import script from "./ActivitySummary.vue?vue&type=script&lang=ts&"
export * from "./ActivitySummary.vue?vue&type=script&lang=ts&"
import style0 from "./ActivitySummary.vue?vue&type=style&index=0&id=3c5801ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5801ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
